<template>
    <div id="NotificationItem">
        <a-row>
            <a-col :span="2">
                <a-icon type="notification" class="noticeIcon" />
            </a-col>
            <a-col :span="20" :offset="1">
                <div class="notice_title">
                    {{data.title}}
                </div>
            </a-col>
        </a-row>
        <a-row style="margin-top: 10px">
            <a-col>
                <div class="notice_content">
                    {{data.content}}
                </div>
            </a-col>
        </a-row>
    </div>
</template>

<script>
    export default {
        name: "NotificationItem",
        props: ['data'],
        data() {
            return {}
        },
        destroyed() {
        },
        created() {
        },
        methods: {}
    }
</script>

<style lang="less" scoped>
    ::-webkit-scrollbar {
        display: none;
    }
    #NotificationItem{
        padding: 10px;
        font-size: 16px;
        white-space:normal;
        border: 8px;
        .noticeIcon{
            font-size: 30px;
            margin-left: 10px;
        }

        .notice_title{
            font-size: 20px;
            line-height: 20px;
            font-weight: 600;
            height: 40px;
            width: 100%;
            word-break:break-all;
            word-wrap:break-word;
            overflow: hidden;
            text-overflow:ellipsis;
            -o-text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
        }
        .notice_content{
            font-size: 14px;
            line-height: 14px;
            font-weight: 400;
            height: auto;
            width: 100%;
            color: #909399;
            word-break:break-all;
            word-wrap:break-word;
            overflow: hidden;
            text-overflow:ellipsis;
            -o-text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
        }
    }

</style>
